import React from "react";
import { Route, Routes } from "react-router-dom";
import { useNewBreadcrumb } from "recoils";
import { DOCUMENTS_ROUTER } from "./consts";
import { UTILITY_BILLS_PAGE, UtilityBillsRouter } from "./document-summary-v2";
import { DOCUMENT_UPLOAD_PAGE, DocumentUploadPage } from "./document-upload";
import { DocumentUploadRouter } from "./document-upload/router";
import { useDefaultSelectionWatcher } from "./hooks";
import { MISSING_DOCUMENTS_PAGE, MissingDocumentsPage } from "./missing-documents";

export const DocumentsRouter = () => {
  useNewBreadcrumb(DOCUMENTS_ROUTER.TITLE);
  useDefaultSelectionWatcher();

  return (
    <Routes>
      <Route path="/*" element={<DocumentUploadRouter />} />
      <Route
        path={DOCUMENT_UPLOAD_PAGE.PATH}
        element={<DocumentUploadPage />}
      />
      <Route path={UTILITY_BILLS_PAGE.PATH} element={<UtilityBillsRouter />} />
      <Route
        path={MISSING_DOCUMENTS_PAGE.PATH}
        element={<MissingDocumentsPage />}
      />
    </Routes>
  );
};
